import { render, staticRenderFns } from "./GeneralTab.vue?vue&type=template&id=20f6f690&scoped=true"
import script from "./GeneralTab.vue?vue&type=script&lang=js"
export * from "./GeneralTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralTab.vue?vue&type=style&index=0&id=20f6f690&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f6f690",
  null
  
)

export default component.exports